<script lang="ts" setup>
definePageMeta({
  layout: 'minimal',
  middleware: ['sanctum:guest'],
})

const { t } = useI18n()

useSeoMeta({
  title: t('auth.forgot_password'),
})
</script>

<template>
  <AuthForgotPasswordForm />
</template>
